export enum DiscordType {
  Azuro = "azuro",
  Overtime = "overtime",
  SX = "sx",
}
